import { Box } from '@mui/system';
import { Rating } from '@care/react-component-lib';
import { Card, CardContent, Typography } from '@mui/material';
import {
  seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_latestReview as LatestReview,
  seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_latestReview_reviewer as Reviewer,
  seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver_member as Member,
  seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_seoSegmentationProvider_provider as Provider,
} from '@/__generated__/seoSegmentationListingPage';
import { ReadMore } from '@/components/common/ReadMore';

export type ReviewCardProps = {
  revieweeName: Member['displayName'] | Provider['name'];
  reviewerName: Reviewer['displayName'];
  comment: LatestReview['comment'];
  rating: LatestReview['rating'];
};

export const ReviewCard = ({ revieweeName, comment, rating, reviewerName }: ReviewCardProps) => {
  return (
    <Card
      sx={{
        border: 'none',
        minHeight: { sm: '375px', md: '250px' },
      }}>
      <CardContent sx={{ '&.MuiCardContent-root': { p: 3 } }}>
        <Typography variant="h3" mb={1}>
          {revieweeName}
        </Typography>
        <Rating defaultValue={rating} readOnly sx={{ mb: 2 }} />
        <Box mb={2}>
          <ReadMore
            component="div"
            showLessLabel="read less"
            showMoreLabel="read more"
            charLimit={140}
            value={comment}
            variant="body2"
          />
        </Box>
        <Typography variant="body3" textAlign="right" sx={{ color: 'text.secondary' }}>
          {`- ${reviewerName}`}
        </Typography>
      </CardContent>
    </Card>
  );
};
